import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { PreparationMethod, StateOfMaterial } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/types';
import { hasValue } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../../../../Data/ReduxViewModels/WorksheetEditor';
import { Field, RadioGroup } from '../../../../../../Core';
import { NamePrefixModifier, withInjectedProps } from '../../../../../../Core/InjectedPropsContext';
import { ListFieldSection, PageSection } from '../../../../../../Layout';
import { getLabelForPortionPreparationMethod, getLabelForPortionState } from '../../../../Helpers';

let SpecimenPreparationPageSection: React.FC<IWorksheetComponent> = ({
  namePrefix,
  createWorksheetSelector,
  disabled,
}) => {
  const dispatch = useDispatch();

  const stateBeforePreparation: StateOfMaterial = useSelector(
    createWorksheetSelector!('WholePortion.Preparation.StateBeforePreparation')
  );
  const isPreparationMethodSet = useSelector(
    pipe(createWorksheetSelector!('WholePortion.Preparation.PreparationMethod'), hasValue)
  );

  // TODO: Should this be here? Why not on the backend?
  useEffect(() => {
    // For "oven-dry" state, only one method is valid so pick it automatically.
    if (disabled) return;
    if (stateBeforePreparation === StateOfMaterial.OvenDry && !isPreparationMethodSet) {
      dispatch(
        actions.setValue({
          name: `${namePrefix}.WholePortion.Preparation.PreparationMethod`,
          value: StateOfMaterial.OvenDry,
          sync: true,
        })
      );
    }
  }, [dispatch, namePrefix, stateBeforePreparation, isPreparationMethodSet, disabled]);

  return (
    <PageSection heading="Specimen Preparation">
      <ListFieldSection>
        <NamePrefixModifier appendNamePrefix={`WholePortion.Preparation`}>
          <Field
            input={<RadioGroup />}
            label="State of Material Prior to Preparation"
            name="StateBeforePreparation"
            options={[
              { label: getLabelForPortionState(StateOfMaterial.Moist), value: StateOfMaterial.Moist },
              { label: getLabelForPortionState(StateOfMaterial.AirDry), value: StateOfMaterial.AirDry },
              { label: getLabelForPortionState(StateOfMaterial.OvenDry), value: StateOfMaterial.OvenDry },
            ]}
          />

          <Field
            input={<RadioGroup />}
            label="Material Preparation Method"
            name="PreparationMethod"
            options={[
              {
                label: getLabelForPortionPreparationMethod(PreparationMethod.Moist),
                value: PreparationMethod.Moist,
                disabled: stateBeforePreparation !== StateOfMaterial.Moist,
              },
              {
                label: getLabelForPortionPreparationMethod(PreparationMethod.AirDry),
                value: PreparationMethod.AirDry,
                disabled: stateBeforePreparation === StateOfMaterial.OvenDry,
              },
              {
                label: getLabelForPortionPreparationMethod(PreparationMethod.OvenDry),
                value: PreparationMethod.OvenDry,
              },
            ]}
            confirmText="Changing the material preparation method may clear data. Are you sure you want to continue?"
            confirm={isPreparationMethodSet}
          />
        </NamePrefixModifier>
      </ListFieldSection>
    </PageSection>
  );
};

SpecimenPreparationPageSection = withInjectedProps(SpecimenPreparationPageSection);

export { SpecimenPreparationPageSection };
export default SpecimenPreparationPageSection;
